export class RouteAux {
  contextPath: string;
  path: string;
  data: any;
  routerLink: string;
  visible: boolean;
  order: number;

  constructor(contextPath: string, path: string, data: any, routerLink: string, order, visible: boolean = true) {
    this.contextPath = contextPath;
    this.path = path;
    this.data = data;
    this.routerLink = routerLink;
    this.visible = visible;
    this.order = order;
  }

}
